/**
 * Image for a gamification level badge.
 */
import * as React from 'react';
import { cn } from '@/lib/utils';
import type { GamificationLevelBadge } from '@/types/gamification.types';
import { resolveLevelBadgeImageSrc } from '@/components/gamification/gamification-utils';

/** Props for {@link GamificationLevelBadgeImage}. */
export interface GamificationLevelBadgeImageProps {
  size?: number;
  levelBadge?: GamificationLevelBadge | null;
  levelNumber?: number | null;
  levelIcon?: string | null;
  className?: string;
  alt?: string;
}

/** Remote icon URL if present; otherwise the bundled image for the resolved tier. */
export const GamificationLevelBadgeImage: React.FC<GamificationLevelBadgeImageProps> = ({
  size = 88,
  levelBadge,
  levelNumber,
  levelIcon,
  className,
  alt = 'Badge de niveau',
}) => {
  const src = resolveLevelBadgeImageSrc({ levelIcon, levelBadge, levelNumber });
  if (!src) return null;

  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      className={cn('object-contain shrink-0', className)}
    />
  );
};
